<template>
  <div id="app" :class="{'loading': $store.state.loading}">
    <transition name="fade">
      <div class="loading-box" v-if="$store.state.loading">
        <div class="loading-spinner"></div>
      </div>
    </transition>

    <div class="toasts">
      <transition-group name="stretch-down">
        <template v-for="(toast, toast_index) in toasts">
          <n-toast :key="`toast-${toast_index}`" :toast="toast"/>
        </template>
      </transition-group>
    </div>

    <router-view/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import NToast from "@/components/NToast";
import {getProfile} from "./http/requests/profile";

export default {
  components: {NToast},
  metaInfo() {
    return {
      titleTemplate(titleChunk) {
        const suffix = 'ناصرین';
        return titleChunk ? `${titleChunk} | ${suffix}` : suffix;
      },
    };
  },
  created() {
    this.getProfile()
  },
  computed: {
    ...mapGetters({toasts: 'getToasts'})
  },
  methods: {
    ...mapActions({
      updateUser: 'auth/updateUser',
      setPageTitle: 'setPageTitle',
      clearNavbarRightActions: 'clearNavbarRightActions',
      clearNavbarLeftActions: 'clearNavbarLeftActions',
      resetScroll: 'resetScroll'
    }),
    getProfile() {
      getProfile().then(response => {
        this.updateUser(response.data.data)
      }).catch(() => {

      })
    }
  },
  watch: {
    '$route': {
      handler(val) {
        this.setPageTitle(val.meta.title ?? null)
        this.clearNavbarRightActions()
        this.clearNavbarLeftActions()
        this.resetScroll()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text);
  direction: rtl;
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;

  &.loading {
    overflow: hidden;
    padding: 1px;
  }

  .loading-box {
    transition: all .3s ease;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--body-bg);
    z-index: var(--z-level-5);

    .loading-spinner {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      border: 3px solid var(--brand-100);
      border-top-color: var(--brand-600);
      animation: app-spin .8s linear infinite;
    }
  }

  .toasts {
    z-index: var(--z-level-4);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: fit-content;
    pointer-events: none;

    > * {
      pointer-events: auto;
    }

    @media (min-width: 992px) {
      top: 16px;
      right: auto;
      left: 24px;
      width: 380px;
    }
  }
}

@keyframes app-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
